import { IUser } from '../interfaces/entities';

/**
 * Helper para identificar o tipo de usuário (Director ou Shareholder)
 * baseado no role_id do usuário
 * 
 * TODO: Quando o backend estiver pronto, ajustar os IDs conforme a estrutura real
 * dos roles no banco de dados
 */

// IDs das roles - ajustar conforme o banco de dados real
export const ROLE_IDS = {
  ADMIN: 1,
  CUSTOMER: 2,
  AGENT: 3,
  DIRECTOR: 4, // Ajustar conforme ID real no banco
  SHAREHOLDER: 5 // Ajustar conforme ID real no banco
};

/**
 * Verifica se o usuário é um diretor
 */
export const isDirector = (user: IUser | null | undefined): boolean => {
  if (!user) return false;
  return user.role_id === ROLE_IDS.DIRECTOR;
};

/**
 * Verifica se o usuário é um acionista
 */
export const isShareholder = (user: IUser | null | undefined): boolean => {
  if (!user) return false;
  return user.role_id === ROLE_IDS.SHAREHOLDER;
};

/**
 * Verifica se o usuário é diretor ou acionista
 */
export const isDirectorOrShareholder = (user: IUser | null | undefined): boolean => {
  return isDirector(user) || isShareholder(user);
};

/**
 * Retorna a label da role do usuário
 */
export const getUserRoleLabel = (user: IUser | null | undefined, t: any): string => {
  if (isDirector(user)) {
    return t('labels.lblDirector') || 'Director';
  }
  if (isShareholder(user)) {
    return t('labels.lblShareholder') || 'Shareholder';
  }
  return t('labels.lblDirectorShareholder') || 'Director/Shareholder';
};

/**
 * Retorna o tipo de role como string
 */
export const getUserRoleType = (user: IUser | null | undefined): 'director' | 'shareholder' | 'unknown' => {
  if (isDirector(user)) return 'director';
  if (isShareholder(user)) return 'shareholder';
  return 'unknown';
};

